import { useEffect } from "react";

const VersionChecker = () => {
    useEffect(() => {
        const checkVersion = async () => {
            try {
                const res = await fetch("/version.json", { cache: "no-store" });
                if (!res.ok) return;
                const data = await res.json();

                const storedVersion = localStorage.getItem("app_version");
                if (storedVersion !== data.version) {
                    localStorage.setItem("app_version", data.version);
                    // Only reload if we actually had a version stored (meaning it's an update, not a first visit)
                    // Or strictly follow user request: "If user has old JS -> page auto-reloads"
                    if (storedVersion) {
                        window.location.reload(); // true is deprecated in standard, reload() forces reload from server in some browsers or just reloads. 
                        // To really force, we can do location.reload()
                    }
                }
            } catch (error) {
                console.error("Failed to check version:", error);
            }
        };

        checkVersion();
    }, []);

    return null;
};

export default VersionChecker;
